import * as React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';



const DialogPrism = ({ open, dialogTitle, scApp, setSCApp, scBLApp, setSCBLApp, scVersion, setSCVersion, preSCBLApp, setPreSCBLApp, preSCVersion, setPreSCVersion, mcbF103, setMcbF103, mcbL485, setMcbL485, mcbVersion, setMcbVersion, preMcbF103, setPreMcbF103, preMcbL485, setPreMcbL485, preMcbVersion, setPreMcbVersion, handleClose }) => {

  function handleSCApp(e) {
    setSCApp(e.target.value);
  }

  function handleSCBLApp(e) {
    setSCBLApp(e.target.value);
  }

  function handleSCVersion(e) {
    setSCVersion(e.target.value);
  }

  function handlePreSCBLApp(e) {
    setPreSCBLApp(e.target.value);
  }

  function handlePreSCVersion(e) {
    setPreSCVersion(e.target.value);
  }

  function handleMcbF103(e) {
    setMcbF103(e.target.value);
  }

  function handleMcbL485(e) {
    setMcbL485(e.target.value);
  }

  function handleMcbVersion(e) {
    setMcbVersion(e.target.value);
  }

  function handlePreMcbF103(e) {
    setPreMcbF103(e.target.value);
  }

  function handlePreMcbL485(e) {
    setPreMcbL485(e.target.value);
  }

  function handlePreMcbVersion(e) {
    setPreMcbVersion(e.target.value);
  }
  return (
  	<Dialog open={open} onClose={handleClose} maxWidth ='md' fullWidth>
        <DialogTitle sx={{ fontSize: '22px', color:"#406599", fontFamily: '"Roboto", "sans-serif"' }}>{dialogTitle}</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            id="scApp"
            label="Stable FW SC App"
            fullWidth
            variant="standard"
            value={scApp}
            onChange={handleSCApp}
          />
          <TextField
            margin="dense"
            id="scBLApp"
            label="Stable FW SC BLApp"
            fullWidth
            variant="standard"
            value={scBLApp}
            onChange={handleSCBLApp}
          />
          <TextField
            margin="dense"
            id="scVersion"
            label="Stable FW SC Version"
            fullWidth
            variant="standard"
            value={scVersion}
            onChange={handleSCVersion}
          />
          <TextField
            margin="dense"
            id="preSCBLApp"
            label="Previous SC BLApp"
            fullWidth
            variant="standard"
            value={preSCBLApp}
            onChange={handlePreSCBLApp}
          />
          <TextField
            margin="dense"
            id="preSCVersion"
            label="Previous SC FW Version"
            fullWidth
            variant="standard"
            value={preSCVersion}
            onChange={handlePreSCVersion}
          />
          <TextField
            margin="dense"
            id="mcbF103"
            label="Stable FW MCB F103 app"
            fullWidth
            variant="standard"
            value={mcbF103}
            onChange={handleMcbF103}
          />
          <TextField
            margin="dense"
            id="mcbL485"
            label="Stable FW MCB L485 app"
            fullWidth
            variant="standard"
            value={mcbL485}
            onChange={handleMcbL485}
          />
          <TextField
            margin="dense"
            id="mcbVersion"
            label="Stable FW MCB version"
            fullWidth
            variant="standard"
            value={mcbVersion}
            onChange={handleMcbVersion}
          />
          <TextField
            margin="dense"
            id="preMcbF103"
            label="Previous Stable FW MCB F103 app"
            fullWidth
            variant="standard"
            value={preMcbF103}
            onChange={handlePreMcbF103}
          />
          <TextField
            margin="dense"
            id="preMcbL485"
            label="Previous Stable FW MCB L485 app"
            fullWidth
            variant="standard"
            value={preMcbL485}
            onChange={handlePreMcbL485}
          />
          <TextField
            margin="dense"
            id="preMcbVersion"
            label="Previous MCB FW Version"
            fullWidth
            variant="standard"
            value={preMcbVersion}
            onChange={handlePreMcbVersion}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Save</Button>
        </DialogActions>
     </Dialog>
  );
}

export default DialogPrism;
